import ApiService from "@/services/api.service";

const state = {
  roles: [],
  modules: [],
  skuList: [],
  departments: [],
  parameters: [],
  parametergroups: [],
  virtualDepartments: [],
};
const getters = {
  getRoles(state) {
    return state.roles;
  },
  getModules(state) {
    return state.modules;
  },
  getSkuList(state) {
    return state.skuList;
  },
  getDepartments(state) {
    return state.departments;
  },
  getParameters(state) {
    return state.parameters;
  },
  getParameterGroups(state) {
    return state.parametergroups;
  },
  getVirtualDepartments(state) {
    return state.virtualDepartments;
  },
};
const actions = {
  fetchRoles({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post(
        "getroles/",
        payload
          ? {
              type: payload.type,
            }
          : { type: 1 },
      )
        .then(({ data }) => {
          commit("setRoles", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchModules({ commit }) {
    return new Promise((resolve) => {
      ApiService.post("getmodules/", { rows: "-1" })
        .then(({ data }) => {
          commit("setModules", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  saveRole({ dispatch, commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("createrole/", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  updateRole({ dispatch, commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("updaterole/", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  deleteRole({ dispatch, commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("deleterole/", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  updateModules({ dispatch, commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("bulkupdateaccessmodule/", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchSkuList({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getskus/", payload)
        .then(({ data }) => {
          commit("setSkuList", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchDepartments({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getdepartments/", payload)
        .then(({ data }) => {
          commit("setDepartments", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchParameters({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getparameters/", payload)
        .then(({ data }) => {
          commit("setParameters", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchParameterGroups({ commit }) {
    return new Promise((resolve) => {
      ApiService.post("getparametergroups/", { rows: "-1" })
        .then(({ data }) => {
          commit("setParameterGroups", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  saveParameter({ dispatch, commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("createparameter/", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  deleteParameter({ dispatch, commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("deleteparameter/", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  updateParameter({ dispatch, commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("updateparameter/", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchVirtualDepartments({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getvirtualdepartments/", payload)
        .then(({ data }) => {
          commit("setVirtualDepartments", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
};
const mutations = {
  setRoles(state, payload) {
    state.roles = payload;
  },
  setModules(state, payload) {
    state.modules = payload;
  },
  setSkuList(state, payload) {
    state.skuList = payload;
  },
  setDepartments(state, payload) {
    state.departments = payload;
  },
  setParameters(state, payload) {
    state.parameters = payload;
  },
  setParameterGroups(state, payload) {
    state.parametergroups = payload;
  },
  setVirtualDepartments(state, payload) {
    state.virtualDepartments = payload;
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
